import Request from '../../request';
const BASE_URI_GO_API = process.env.API_GO_URL + '/api/v1';

const AtualizaPropostaBndes = async(data) => {
    try{

        return await Request.AxiosAuthPut(`${BASE_URI_GO_API}/parceiros/bndes/atualiza`, data);

    } catch(error) {
        throw new Error(`Erro ao atualizar bndes`);
    }
}

export default {AtualizaPropostaBndes}




// WEBPACK FOOTER //
// ./src/services/api/bndes/index.js